<div class="doctor-card bg-white p-5 w-100 max-450 height-570 border-radius-10 m-auto mrb-10 mrb-md-0 box-shadow">
    <div class="doctor-card-img hover-img">
        <img class="w-100 max-430 height-450" [src]="image" alt="card img" defaultImage>
    </div>
    <div class="doctor-card-body text-center">
        <div class="doctor-name weight-700 pt-5 size-12">{{ name }}</div>
        <div class="doctor-specialty text-gray1 weight-600 ptb-5 size-3">{{ position }}</div>
    </div>
  </div>
  